// Lib
import React, { ReactElement } from 'react';

// Hooks
import { holdFocusWithoutKeyboard } from '../../../boardsPage/editing/touchScreenFocusUtils';
import useSheet from '../../../structural/sheet/hooks/useSheet';

// Components
import TextStyleRichTextTool from '../../../../workspace/toolbar/components/selectionTools/editorTools/TextStyleRichTextTool';
import SheetContainer, { Content, Overlay, Sheet } from '../../../structural/sheet';
import { useGroupTranslator } from '../../../../components/i18n/GroupTranslationContext';

// Types
import { ImMNElement } from '../../../../../common/elements/elementModelTypes';
import { ImMNCurrentUser, MNCurrentUser } from '../../../../user/currentUserSelector';
import { SheetId } from '../../../structural/sheet/sheetTypes';

// Styles
import './MobileTextStyleRichTextTool.scss';

export type MobileTextStyleRichTextSheetProps = {
    currentUser: ImMNCurrentUser | MNCurrentUser;
    currentUserId: string;
    currentBoardId: string;
    gridSize: number;
    gridSizeName: string;
    permissions: number;
    selectedElementIds: Immutable.List<string>;
    selectedElements: Immutable.List<ImMNElement>;
    editorKey: string;
    hasEditorSelection: boolean | undefined;
};

type MobileTextStyleRichTextSheetComponentProps = MobileTextStyleRichTextSheetProps & {
    SheetContentComponent: React.ComponentType<MobileTextStyleRichTextSheetProps>;
    sheetId?: SheetId;
};

// FIXME-MOBILE - Add a style to the current editor to show the current selection
//  NOTE: Investigate whether it might be easier to do this using vanilla JS, so that we don't
//        accidentally save the selection state to the DB
const MobileTextStyleRichTextSheet = (props: MobileTextStyleRichTextSheetComponentProps): ReactElement => {
    const { SheetContentComponent, sheetId = SheetId.TextStyleRichTextTool, ...sheetContentProps } = props;
    const sheetProps = useSheet(sheetId);
    const translate = useGroupTranslator();

    const onClickToolButton = () => {
        sheetProps.dispatchOpenSheet();
    };

    const textStyleText = translate('toolbar:mobile.textStyle');

    return (
        <div className="MobileTextStyleRichTextTool">
            <div onClick={onClickToolButton}>
                <TextStyleRichTextTool isOpen={sheetProps.isSheetOpen} name={textStyleText} />
            </div>
            <SheetContainer
                {...sheetProps}
                className="text-style-rich-text-tool"
                onCloseTransitionStart={holdFocusWithoutKeyboard}
            >
                <Overlay />
                <Sheet>
                    <Content>
                        <div data-table-util>
                            <SheetContentComponent {...sheetContentProps} />
                        </div>
                    </Content>
                </Sheet>
            </SheetContainer>
        </div>
    );
};

export default MobileTextStyleRichTextSheet;
